const VisualComponent = require('./VisualComponent');

class StickyHeader extends VisualComponent {
    // TODO improve this file
    constructor(articleView, config) {
        super();

        this.config = config;
        this.main = document.body.querySelector(config.stickyHeader.selectors.stickyHeader);

        if (!config.stickyHeader.enable || !this.main) return;

        this.classNames = config.classNames;
        this.articleView = articleView;
        this.article = articleView.getArticle();

        this.selectors = config?.stickyHeader.selectors;

        this.stickyHeaderSelectorMap = {
            tracker: this.main.querySelector(this.selectors.tracker),
            title: this.main.querySelector(this.selectors.title),
            titleLabel: this.main.querySelector(this.selectors.titleLabel),
            alerts: this.main.querySelector(this.selectors.alerts),
            citations: this.main.querySelector(this.selectors.citations),
            favorite: this.main.querySelector(this.selectors.favorite),
            formats: this.main.querySelector(this.selectors.formats),
            logo: this.main.querySelector(this.selectors.logo),
            sequentialNav: this.main.querySelector(this.selectors.navigation),
            share: this.main.querySelector(this.selectors.share),
        };

        this.trackWindowScroll = this.trackWindowScroll.bind(this);
    }

    initiate() {
        if (!this.config.stickyHeader.enable || !this.main) return;
        try {
            this.updateStickyHeaderItems(this.selectors);

            if (this.config?.stickyHeader.reposition) {
                (
                    document.body.querySelector(this.config?.stickyHeader.repositionLocation) || document.body
                ).appendChild(this.main); // has to be appended on the constructor to provide measurements of the top offset
            }
        } catch (e) {
            console.debug('Section Navigation - initiate: ' + e);
        }
        this.articleView.subscribe('mobileOff', () => {
            this.enable();
            this.articleView.addTopOverlay(this.main.getBoundingClientRect().height);
        });
        this.articleView.subscribe('mobileOn', () => {
            this.articleView.subtractTopOverlay(this.main.getBoundingClientRect().height);
            this.disable();
        });
    }

    updateStickyHeaderItems(selectors) {
        this.updateFavoriteItem(selectors.articleFavorite);
        this.updateCitationItem(selectors.articleCitation);
        this.updateLogoItem(selectors.articleLogo);
        this.updateFormatItem(selectors.articleFormats);
        this.updateCiteItem(selectors.cite);
        this.updateMenueItem(selectors.menu);
        this.updateNavigationItem();
        this.updateTitleItem();
    }

    updateFavoriteItem(articleFavorite) {
        const favoriteSource = this.articleView.getArticle().querySelector(articleFavorite);
        if (favoriteSource && this.stickyHeaderSelectorMap.favorite) {
            const favoriteContent = favoriteSource.cloneNode(true);
            favoriteContent.classList.remove(this.classNames.BTN, this.classNames.BTN_INVERSE);
            this.stickyHeaderSelectorMap.favorite.appendChild(favoriteContent);
        }
    }

    updateCiteItem(articleCite) {
        const citeSource = this.articleView.getArticle().querySelector(articleCite);
        if (citeSource && this.stickyHeaderSelectorMap.citations) {
            this.stickyHeaderSelectorMap.citations.innerHTML = citeSource.innerHTML;
        }
    }

    updateFormatItem(articleFormats) {
        const formatsSource = this.articleView.getArticle().querySelector(articleFormats);
        if (formatsSource && this.stickyHeaderSelectorMap.formats) {
            this.stickyHeaderSelectorMap.formats.innerHTML = formatsSource.innerHTML;
        }
    }

    updateLogoItem(articleLogo) {
        const logoSource = document.body.querySelector(articleLogo);
        if (logoSource && this.stickyHeaderSelectorMap.logo) {
            this.stickyHeaderSelectorMap.logo.innerHTML = logoSource.innerHTML;
            if (logoSource.href) {
                this.stickyHeaderSelectorMap.logo.href = logoSource.href;
            }
        }
    }

    updateCitationItem(articleCitation) {
        const alertsSource = this.articleView.getArticle().querySelector(articleCitation);
        if (alertsSource && this.stickyHeaderSelectorMap.alerts) {
            const alertsContent = alertsSource.cloneNode(true);
            alertsContent.classList.remove(this.classNames.BTN, this.classNames.BTN_INVERSE);
            this.stickyHeaderSelectorMap.alerts.appendChild(alertsContent);
            this.stickyHeaderSelectorMap.alerts.classList.remove(this.classNames.HIDDEN);
        } else if (this.stickyHeaderSelectorMap.alerts) {
            this.stickyHeaderSelectorMap.alerts.classList.add(this.classNames.HIDDEN);
        }
    }

    updateNavigationItem() {
        this.navigationLinks = this.articleView.source.data.navigation;
        if (this.navigationLinks && this.stickyHeaderSelectorMap.sequentialNav) {
            if (this.stickyHeaderSelectorMap.sequentialNav.childNodes.length === 0) {
                this.stickyHeaderSelectorMap.sequentialNav.appendChild(this.navigationLinks.cloneNode(true));
            }
        }
    }

    updateTitleItem() {
        if (this.stickyHeaderSelectorMap.title) {
            const {breadcrumbs, selectors} = this.config?.stickyHeader;

            const renderTitle = () => {
                var title = sessionStorage.getItem('title');
                if (title && this.stickyHeaderSelectorMap.title) {
                    this.stickyHeaderSelectorMap.title.innerHTML = title.replace(/[<]br[^>]*[>]/gi, '');
                }
            };
            const renderBreadcrumbs = content => {
                content && this.stickyHeaderSelectorMap.title.insertAdjacentHTML('beforebegin', content.outerHTML);
            };

            if (breadcrumbs) {
                const content = document.querySelector(selectors.articleBreadcrumbs);
                if (content) {
                    renderBreadcrumbs(content);
                    this.stickyHeaderSelectorMap.title?.remove();
                    this.stickyHeaderSelectorMap.titleLabel?.remove();
                } else {
                    renderTitle();
                }
            } else {
                renderTitle();
            }
        }
    }

    updateMenueItem(menu) {
        this.menu = document.querySelector(menu);
        if (this.menu) {
            const prefix = 'core-';
            const clonedMenu = this.menu.cloneNode(true);
            try {
                this.config.stickyHeader.identifyingAttributes.forEach(attribute =>
                    clonedMenu
                        .querySelectorAll(`[${attribute}]`)
                        .forEach(el => el.setAttribute(attribute, prefix + el.getAttribute(attribute)))
                );
            } catch (error) {
                console.debug('Sticky header - cloning - changing ID attributes', error);
            }
            this.main.querySelector('.st-header__menu').appendChild(clonedMenu);
        }
    }

    enable() {
        this.trackWindowScroll();
        this.articleView.subscribe('scroll', this.trackWindowScroll);
    }

    disable() {
        this.main.classList.remove(this.classNames.JS_VISIBLE);
        this.articleView.subscribe('scroll', this.trackWindowScroll, true);
    }

    trackWindowScroll() {
        const articleProgress = () => {
            if (!this.stickyHeaderSelectorMap.tracker || !this.article) return;
            const {top, height} = this.article.getBoundingClientRect();
            const newPos = ((window.scrollX - top) / (height - window.innerHeight)) * 100;
            this.stickyHeaderSelectorMap.tracker.style.width = newPos < 0 ? 0 : newPos + '%';
        };
        this.articleView.articleFixedHeader?.trackWindowScroll(this.main, this.article, articleProgress);
    }
}

module.exports = StickyHeader;
